import React from 'react';

const AddedComponents = ({ add }) => add.map((item, idx) => <item.comp key={`formAddElem${idx}`} />);
export default AddedComponents;
